/**
 * @owner @Appboy/content-cards
 */

// generated from 1_072 samples

import { z } from "zod";
import { stepGetBaseSchema } from "./stepGetBaseSchema";

export const featureFlagStepGetSchema = z.object({
  ...stepGetBaseSchema.shape,
  type: z.literal("FEATURE_FLAG"),
  step_data: z.object({
    // null: 3 (0.28%)
    override_enabled: z.literal(true).nullable(),
    // null: 121 (11.29%)
    override_properties: z.string().nullable(),
    // format object-id: 834 (77.80%)
    parent_rollout_id: z.string(),
    // null: 235 (21.92%)
    // format integer: 834 (99.64%)
    parent_rollout_nst: z.string().nullable(),
  }),
});
